const VALID_RETURN_KEY = /^[A-Za-z0-9_]+$/;

export const findInvalidReturnKeys = (code: string): string[] => {
  const invalid: string[] = [];
  const returnRe = /return\s*\{/g;
  let match: RegExpExecArray | null;
  while ((match = returnRe.exec(code)) !== null) {
    const start = match.index + match[0].length - 1;
    let depth = 1;
    let i = start + 1;
    while (i < code.length && depth > 0) {
      const character = code[i];
      if (character === '{') depth++;
      else if (character === '}') depth--;
      else if (character === '"' || character === "'") {
        const quote = character;
        i++;
        while (i < code.length && code[i] !== quote) {
          if (code[i] === '\\') i++;
          i++;
        }
      }
      i++;
    }
    if (depth !== 0) continue;
    const block = code.slice(start + 1, i - 1);
    const keyRe = /['"]([^'"]+)['"]\s*:/g;
    let keyMatch: RegExpExecArray | null;
    while ((keyMatch = keyRe.exec(block)) !== null) {
      const key = keyMatch[1];
      if (!VALID_RETURN_KEY.test(key) && !invalid.includes(key)) {
        invalid.push(key);
      }
    }
  }
  return invalid;
};
